const sliceObj = (obj, keys) =>
  keys.reduce((newObj, key) => {
    if (obj[key] !== undefined)
      newObj[key] = obj[key]
    return newObj
  }, {})

export default sliceObj
